import { IUser } from '../../../typings/interfaces/user.interface';

export type TShelterClusterUserModalViewMode = 'CREATE' | 'EDIT' | 'PORTFOLIO' | 'REMOVE';

export const SHELTER_CLUSTER_USER_BTN_CONFIG = {
  CREATE: 'Create',
  EDIT: 'Save',
  NEXT: 'Continue',
  CREATE_LONG: 'Create user',
  EDIT_LONG: 'Save changes',
};

export interface IShelterClusterUserIdentifier {
  name: string;
  id: string;
}

export interface IShelterClusterUserModalShellData {
  projectionColumns?: string[];
  user?: IShelterClusterUserIdentifier;
  mode: TShelterClusterUserModalViewMode;
  currentUser?: IUser;
}
